// src/components/Dashboard.js
import React, { useState } from 'react';
import { Box, Tabs, TabList, TabPanels, Tab, TabPanel, Flex } from '@chakra-ui/react';
import SensorList from './SensorList';
import GatewayList from './GatewayList';
import GatewayDashboard from './GatewayDashboard';
import SensorForm from './SensorForm'; // Import SensorForm
import SensorDashboard from './SensorDashboard'; // Import SensorDashboard

const Dashboard = () => {
  const [selectedGateway, setSelectedGateway] = useState(null);
  const [selectedSensor, setSelectedSensor] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const handleViewSensor = (sensor) => {
    setSelectedSensor(sensor);
  };

  const handleEditSensor = (sensor) => {
    setSelectedSensor(sensor);
    setShowForm(true);
  };

  const handleFormSubmit = () => {
    setShowForm(false);
    setSelectedSensor(null);
  };

  const handleViewGateway = (gateway) => {
    setSelectedGateway(gateway);
  };

  return (
    <Box p={4}>
      <Tabs variant="enclosed">
        <TabList>
          <Tab>Sensors</Tab>
          <Tab>Gateways</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>

              <Box>
                <SensorList onEdit={handleEditSensor} onView={handleViewSensor} />
              </Box>
              <Box>
                {showForm ? (
                  <SensorForm sensor={selectedSensor} onSubmit={handleFormSubmit} />
                ) : selectedSensor ? (
                  <SensorDashboard sensor={selectedSensor} />
                ) : (
                  <Box>Select a sensor to view details</Box>
                )}
              </Box>
          </TabPanel>
          <TabPanel>
            <GatewayList onView={handleViewGateway} />
            {selectedGateway && (
              <Box >
                <GatewayDashboard gateway={selectedGateway} />
              </Box>
            )}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default Dashboard;